import React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      viewBox="0 0 512 512"
      width="48px"
      height="48px"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#283f71}"}</style>
      </defs>
      <title>{"icons"}</title>
      <path
        className="prefix__cls-1"
        d="M217.24 511C97.45 511 0 413.58 0 293.82S97.45 76.57 217.24 76.57a217.22 217.22 0 01144.25 54.84 4.2 4.2 0 01-5.58 6.29A208.8 208.8 0 00217.24 85C102.08 85 8.4 178.66 8.4 293.82S102.08 502.6 217.24 502.6 426 408.94 426 293.82a208.8 208.8 0 00-50.9-136.69 4.21 4.21 0 01-1.54-7.25l.51-.43a4.21 4.21 0 015.85.43 217.2 217.2 0 0154.48 143.94C434.42 413.58 337 511 217.24 511zM447.09 124a29.83 29.83 0 01-8.24-1.17l-38.08-9.22a4.18 4.18 0 01-3.09-3.1l-9.21-38.18a29.24 29.24 0 017.69-28.92l42.2-42.18a4.2 4.2 0 017 2l12.53 50.25L508.17 66a4.16 4.16 0 013 3 4.2 4.2 0 01-1.07 4.1l-42.16 42.1a29.39 29.39 0 01-20.85 8.8zm-41.85-18l35.76 8.71a21.86 21.86 0 006.1.89 21 21 0 0014.9-6.34l36.94-36.94L453.45 61a4.24 4.24 0 01-3.06-3.06l-11.34-45.5-36.94 36.91a20.74 20.74 0 00-5.52 20.84z"
      />
      <path
        className="prefix__cls-1"
        d="M217.24 471.58c-98.06 0-177.84-79.74-177.84-177.76S119.18 116 217.24 116A177.47 177.47 0 01333 158.9a4.2 4.2 0 01-5.48 6.36 169.13 169.13 0 00-110.32-40.87c-93.43 0-169.43 76-169.43 169.43s76 169.36 169.43 169.36 169.38-76 169.38-169.36a169.44 169.44 0 00-40.24-109.68 4.2 4.2 0 116.4-5.44A177.86 177.86 0 01395 293.82c0 98.02-79.73 177.76-177.76 177.76z"
      />
      <path
        className="prefix__cls-1"
        d="M217.24 428.45c-74.23 0-134.63-60.4-134.63-134.63S143 159.19 217.24 159.19a134.55 134.55 0 0186.13 31.19 4.2 4.2 0 11-5.39 6.45 125.7 125.7 0 1016.19 16.11 4.2 4.2 0 016.45-5.38 134.79 134.79 0 0131.26 86.26c0 74.23-60.4 134.63-134.64 134.63z"
      />
      <path
        className="prefix__cls-1"
        d="M217.24 384.22a90.44 90.44 0 1155.89-161.5 4.2 4.2 0 11-5.21 6.58 82 82 0 1013.28 13.14 4.2 4.2 0 116.54-5.26 89.54 89.54 0 0119.91 56.64 90.51 90.51 0 01-90.41 90.4z"
      />
      <path
        className="prefix__cls-1"
        d="M217.24 298a4.21 4.21 0 01-4-5.4c3.83-12.95 53.65-72.53 182-200.89a4.21 4.21 0 017.06 2l3 12.33 12.41 3a4.21 4.21 0 012 7.06C312.37 223.41 233.26 294.76 218.1 297.94a4.92 4.92 0 01-.86.06zm178.62-195C295 204 247.93 257.46 230.12 281.1c24.85-18.73 81.7-69.25 178.29-165.62l-7.65-1.87a4.2 4.2 0 01-3.08-3.1zm73.34-38.24a4.44 4.44 0 01-1-.13L453.46 61a4.23 4.23 0 01-3.07-3.07l-3.66-14.74a4.22 4.22 0 011.11-4l20.8-20.81a17.29 17.29 0 0124.33 0 16.85 16.85 0 010 24.33l-20.8 20.81a4.24 4.24 0 01-2.97 1.24zm-11.27-11.33l10 2.47L487 36.78a8.54 8.54 0 000-12.46 8.69 8.69 0 00-12.45 0l-19.09 19.14z"
      />
      <path
        className="prefix__cls-1"
        d="M217.24 335.47a41.69 41.69 0 1124.2-75.65 4.21 4.21 0 01.79 6.1c-5.07 6.12-8.92 11-11.84 14.86 3.84-2.89 8.71-6.72 14.84-11.8a4.21 4.21 0 016.1.81 41.17 41.17 0 017.63 24 41.73 41.73 0 01-41.72 41.68zm0-75a33.28 33.28 0 1033.32 33.32 32.93 32.93 0 00-3.71-15.3c-22.18 18-26.91 19-28.75 19.42a4.22 4.22 0 01-3.93-1.26 4.16 4.16 0 01-1-4c.85-3 3.86-9.24 19.49-28.4a33.18 33.18 0 00-15.42-3.75z"
      />
    </svg>
  )
}

export default SvgComponent
